// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2698":"3b53517f","7957":"3b53517f","9715":"3b53517f"}[chunkId] + ".chunk.css";
};